(function () {

    angular.module('app')
        .controller('ClientAccountsController', function (
            $scope,
            ClientService,
            $routeParams,
            $location,
            toastr,
            ConfirmationModalFactory,
            $timeout,
            ClientsListsRepositoryFactory,
            AuthenticationService,
            scrollToForm,
            ViewChangeNotificationFactory,
            aborter,
            $rootScope
        ) {

            let vm = this;
            vm.clientModel = {};
            vm.clientModel.active = false;
            vm.clientModel.twoFactor = {};
            vm.clientModel.twoFactor.twoFactorStatus = false;
            vm.clientsLists = ClientsListsRepositoryFactory;
            vm.params = $routeParams || {};
            vm.clientId = vm.params.id || undefined;
            vm.companyId = vm.params.companyId || undefined;
            vm.groupId = vm.params.groupId || undefined;
            vm.locationId = vm.params.locationId || undefined;
            vm.isViewMode = false;
            vm.goTo = goTo;
            vm.save = save;
            vm.changeStatus = changeStatus;
            vm.twoFactorOnchange = twoFactorOnchange;
            vm.resetPassword = resetPassword;
            vm.searchForGroups = searchForGroups;
            vm.searchForLocations = searchForLocations;
            vm.fetching = fetchingFn;
            vm.tooltipGroup = false;
            vm.tooltipLocation = false;

            let fetching = {};
            let onRouteChangeOff = $rootScope.$on('$routeChangeStart', routeChange);

            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.viewChange.MESSAGE',
                code: 'messages.warning.viewChange.CODE',
            });

            const toInactiveConf = new ConfirmationModalFactory({}, {
                message: 'messages.warning.statusChange.MESSAGE.TO_ACCOUNT_INACTIVE',
                code: 'messages.warning.statusChange.CODE'
            });

            const toActiveConf = new ConfirmationModalFactory({}, {
                message: 'messages.warning.statusChange.MESSAGE.TO_ACCOUNT_ACTIVE',
                code: 'messages.warning.statusChange.CODE'
            });
            init();

            function init() {
                if (vm.locationId) {
                    vm.clientsLists.lists.locations.update({ company: vm.companyId, id: vm.locationId }).then(function (data) {
                        setLocationAndGroup();
                    });
                } else if (vm.groupId) {
                    vm.clientsLists.lists.groups.update({ company: vm.companyId, id: vm.groupId }).then(function () {
                        setLocationAndGroup();
                    });
                } else {
                    setLocationAndGroup();
                    setVerificationMethodAndOTP();
                }
                if (vm.clientId) {
                    vm.isFetching = true;
                    ClientService.Account.get(vm.clientId, function (data) {
                        vm.clientModel = data;
                        if (angular.getObjVal(vm.clientModel, 'twoFactor.twoFactorStatus')) {
                            vm.isViewModeMFA = vm.clientModel.twoFactor.twoFactorStatus;
                            vm.clientModel.twoFactor.tokenType = vm.methodList.find(method => method.value === data.twoFactor.tokenType);
                            vm.clientModel.twoFactor.tokenExpireIn = vm.otpList.find(otp => otp.value === data.twoFactor.tokenExpireIn);
                        }
                        vm.clientModelRaw = angular.copy(vm.clientModel);
                        vm.isFetching = false;
                    });
                }
            }

            function setVerificationMethodAndOTP() {
                vm.methodList = [
                    { name: 'Authenticator App', value: 'authenticator' },
                    { name: 'Email', value: 'email' }
                ];
                vm.otpList = [
                    { name: '14 days', value: 'fourteen_days' },
                    { name: '1 Month', value: 'one_month' },
                    { name: '3 Months', value: 'three_months' },
                    { name: '6 Month', value: 'six_months' },
                    { name: '1 Year', value: 'one_year' }
                ]
            }

            function setLocationAndGroup() {
                if (vm.groupId) {
                    vm.clientsLists.lists.groups.content.find(function (group) {
                        if (group.id.toString() === vm.groupId) {
                            vm.clientModel.permissionGroup = group;
                            return true;
                        }
                        return false;
                    })
                }

                if (vm.locationId) {
                    vm.clientsLists.lists.locations.content.find(function (loc) {
                        if (loc.id.toString() === vm.locationId) {
                            vm.clientModel.office = loc;
                            return true;
                        }
                        return false;
                    });
                }

                vm.clientModelRaw = angular.copy(vm.clientModel);
            }
            function changeStatus(event) {
                event.preventDefault();
                if (vm.clientModel.office && vm.clientModel.permissionGroup) {
                    if (vm.clientModel.active) {
                        vm.clientModel.active = false;
                        toActiveConf.getInstance().result.then(function (cond) {
                            if (cond) {
                                $timeout(function () {
                                    vm.clientModel.active = true;
                                });
                            }
                        });
                    }
                    else {
                        vm.clientModel.active = true;
                        toInactiveConf.getInstance().result.then(function (cond) {
                            if (cond) {
                                $timeout(function () {
                                    vm.clientModel.active = false;
                                });
                            }
                        });
                    }
                }
            }

            function twoFactorOnchange() {
                if (!angular.getObjVal(vm.clientModel, 'twoFactor.twoFactorStatus')) {
                    vm.clientModel.twoFactor.tokenType = "";
                    vm.clientModel.twoFactor.tokenExpireIn = "";
                    vm.clientModel.twoFactor.enforceMfa = false;
                }
            }

            function save(form) {
                form.email.$setValidity('emailTaken', true);

                form.$setSubmitted();
                if (form.$invalid) {
                    if (angular.getObjVal(vm.clientModel, 'twoFactor.twoFactorStatus')) {
                        if (!vm.clientModel.twoFactor.tokenType || !vm.clientModel.twoFactor.tokenExpireIn) {
                            toastr.error('Verification Method and Ask For OTP are required');
                        }
                    }
                    scrollToForm(form.$name);
                    return
                }

                vm.savingData = true;
                let requestData = angular.copy(vm.clientModel);
                requestData.companyId = vm.companyId;

                if (vm.clientModel.permissionGroup) {
                    requestData.permissionGroupId = vm.clientModel.permissionGroup.id;
                    delete requestData.permissionGroup;
                }

                if (vm.clientModel.office) {
                    requestData.officeId = vm.clientModel.office.id;
                    delete requestData.office;
                }

                if (angular.getObjVal(vm.clientModel, 'twoFactor.twoFactorStatus')) {
                    if (!vm.clientModel.twoFactor.tokenType.value || !vm.clientModel.twoFactor.tokenExpireIn.value) {

                    }
                    requestData.twoFactor.tokenType = vm.clientModel.twoFactor.tokenType.value;
                    requestData.twoFactor.tokenExpireIn = vm.clientModel.twoFactor.tokenExpireIn.value;
                }

                if (vm.clientId) {
                    ClientService.Account.update(requestData, function (response) {
                        vm.clientModelRaw = angular.copy(vm.clientModel);
                        toastr.success("Account has been updated");
                        init()
                        vm.savingData = false;
                    }, function (err) {
                        toastr.error(err.message);
                        vm.savingData = false;
                    }, vm.clientId);
                } else {
                    ClientService.Account.create(requestData, function (response) {
                        toastr.success("Account has been created");
                        init()
                        onRouteChangeOff();
                        $location.path(`/clients/${vm.companyId}/account/${response.id}`);
                    }, function (err) {
                        if (err.code == 412) {
                            toastr.warning(err.message, 'Form Error');
                            setFormError(err.message, form);
                        }
                        else {
                            toastr.error(err.message, err.code);
                        }
                        vm.savingData = false;
                    });
                }
            }

            function setFormError(message, form) {
                if (message.indexOf("email") !== -1) {
                    form.email.$setValidity('emailTaken', false);
                }
            }

            function goTo(path, params) {
                $location.path(path).search(params);
            }

            function routeChange(event, next, current) {
                let path = next.$$route.originalPath.replace(':companyId', next.params.companyId);
                if (!vm.isViewMode && !angular.equals(vm.clientModel, vm.clientModelRaw)) {
                    event.preventDefault();
                    viewConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            onRouteChangeOff();
                            $location.path(path).search({ tab: next.params.tab });
                        }
                    });
                }
            }

            function searchForGroups(select) {
                if (select.open) {
                    vm.clientsLists.lists.groups.content = [];
                    fetching.groups = true;
                    aborter(() => {
                        vm.clientsLists.lists.groups.update({
                            company: vm.companyId, name: select.search
                        }).then(() => {
                            delete fetching.groups;
                        }).catch(() => {
                            delete fetching.groups;
                        });
                    }, 500);
                }
            }

            function searchForLocations(select) {
                if (select.open) {
                    vm.clientsLists.lists.locations.content = [];
                    fetching.locations = true;
                    aborter(() => {
                        vm.clientsLists.lists.locations.update({
                            company: vm.companyId, name: select.search
                        }).then(() => {
                            delete fetching.locations;
                        }).catch(() => {
                            delete fetching.locations;
                        });
                    }, 500);
                }
            }
            function resetPassword() {
                if (!vm.clientModel || !vm.clientModel.active) return;

                vm.resetInProgress = true;

                AuthenticationService.passwordReset(
                    {
                        email: vm.clientModel.email,
                        resellerId: vm.clientModel.company.resellerId || 1,
                        clientId: vm.clientModelRaw.permissionGroup.roles.find(role => role.code === 'ROLE_ADMIN') ? authParams['client_id'] : companyAuthParams['client_id']
                    },
                    function (response) {
                        if (response && response.status === 200) {
                            vm.errorsForm = {
                                'code': 'Success',
                                'message': 'You have successfully created a new account. We will send password setup instructions to ' + vm.clientModel.email,
                                'type': 'success'
                            };
                            toastr.success('Password reset email successfuly sent. Please check your inbox.', 'Email successfully sent');
                        }
                        vm.resetInProgress = false;
                    }, function (error) {
                        toastr.error(error.data.message || 'Contact administrator if this error will occur again', error.data.code);
                        vm.resetInProgress = false;
                    });
            }
            function fetchingFn() {
                return !angular.equals(fetching, {});
            }
        });

    'use strict';
})();



// WEBPACK FOOTER //
// ./js/controllers/client/ClientAccountsController.js